// extracted by mini-css-extract-plugin
module.exports = {"root":"InventoryLicencesModal_root__1qlo3","container":"InventoryLicencesModal_container__2f3cZ"};